import { ChartTooltipWrapper } from '@modules/charts/components/ChartTooltipWrapper';
import { ChartTooltipWrapperProps } from '@modules/charts/components/ChartTooltipWrapper/ChartTooltipWrapper';
import { TooltipPosition } from '@modules/charts/types';
import { useSearchAnalysesWhereClause } from '@modules/feed/hooks';
import { useFeedStore } from '@modules/feed/store/feedStore';
import { TimeRange } from 'v2/core/entities';
import { FieldNames } from 'v2/core/entities/fields';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

interface SearchSummaryPredictionTooltipProps {
  tooltipData: ChartTooltipWrapperProps['payload'] | null;
  showTooltip: boolean;
  tooltipPosition: TooltipPosition | null;
  setShowTooltip: (shouldShow: boolean) => void;
  setTooltipPosition: (position: TooltipPosition | null) => void;
}

export const SearchSummaryPredictionTooltip = ({
  tooltipData,
  tooltipPosition,
  setShowTooltip,
  showTooltip,
  setTooltipPosition,
}: SearchSummaryPredictionTooltipProps) => {
  const whereClause = useSearchAnalysesWhereClause();
  const duration = useFeedStore(({ query }) => query.duration);

  return (
    <ChartTooltipWrapper
      payload={tooltipData}
      baseWhereClause={whereClause}
      showTooltip={showTooltip}
      tooltipPosition={tooltipPosition}
      setShowTooltip={setShowTooltip}
      setTooltipPosition={setTooltipPosition}
      fieldName={FieldNames.Reason}
      dateRange={duration as TimeRange}
      shouldShowAddToFilter={true}
      formulaID={EQLFunctionName.Count}
      measuredAsCriteria={null}
      shouldShowEditReason={false}
      shouldShowMergeReason={false}
      isSingleRecordQuery={false}
      shouldHideOpenInSearchOnFeedbackDrawer
    />
  );
};
